/**
 * Payment queries — Stripe session verification and billing portal.
 *
 * Used by: PaymentSuccess, AccountPage
 */
import { invokeEdgeJson } from './_edge'
import { VERIFY_SESSION, BILLING_PORTAL } from './_endpoints'

/**
 * Verify a Stripe checkout session via the verify-session edge function.
 * Returns { verified, plan, mode } on success.
 */
export async function verifyStripeSession(sessionId) {
  return invokeEdgeJson(
    VERIFY_SESSION,
    { session_id: sessionId },
    { errorMessage: 'Verification failed' }
  )
}

/**
 * Get a Stripe Customer Portal URL for billing management.
 * Returns the portal URL string.
 */
export async function getBillingPortalUrl() {
  const { url } = await invokeEdgeJson(
    BILLING_PORTAL,
    { return_url: window.location.origin + '/account' },
    { errorMessage: 'Could not open billing portal' }
  )
  return url
}
